import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=2c1af16a&scoped=true&lang=pug&"
import script from "./GlobalMenu.vue?vue&type=script&lang=js&"
export * from "./GlobalMenu.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMenu.vue?vue&type=style&index=0&id=2c1af16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1af16a",
  null
  
)

export default component.exports